/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

const defaultState = {
  userLoginRes: {},
  userProfile: {},
  totalCount: "",
  userSettings: {},
};
const arrayToObject = (array) =>
  array.reduce((obj, item) => {
    obj[item.property] = item.value;
    return obj;
  }, {});

export default (state = defaultState, action) => {
  switch (action.type) {
    case "USER_LOGIN_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "USER_LOGIN_FULFILLED": {
      // console.log("User logged in", action.payload);
      return {
        ...state,
        userLoginRes: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "USER_LOGIN_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload },
      };
    }
    case "GET_USER_DETAIL_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_USER_DETAIL_FULFILLED": {
      //  sessionStorage.setItem(
      //   "addUserDetails",
      //   JSON.stringify(action.payload.data[0])
      //  );
      return {
        ...state,
        userProfile: { ...state.userProfile, ...action.payload.data[0] },
        totalCount: action.payload.data[1].processCount,
        loading: false,
        errors: {},
      };
    }
    case "GET_USER_DETAIL": {
      return {
        ...state,
        userProfile: { ...state.userProfile, ...action.payload },
        loading: false,
        errors: {},
      };
    }
    case "GET_USER_DETAIL_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload },
      };
    }
    case "GET_USER_SETTINGS_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_USER_SETTINGS": {
      return {
        ...state,
        userSettings: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "UPDATE_USER_SETTINGS": {
      console.log(action.payload);
      const updatedSettings = { ...state.userSettings, ...action.payload };
      return {
        ...state,
        userSettings: updatedSettings,
        loading: false,
        errors: {},
      };
    }
    // case "GET_USER_SETTINGS_REJECTED": {
    //  return {
    //   ...state,
    //   loading: false,
    //   errors: { global: action.payload },
    //  };
    // }

    case "UPDATE_IMAGE_PROCESS_AND_BALANCE_AMOUNT": {
      return {
        ...state,
        imageProcessAndBalanceAmount: action.payload,
      };
    }
    case "GET_USER_SETTINGS_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload },
      };
    } //   store
    case "UPDATE_USER_DETAIL": {
      return {
        ...state,
        userProfile: { ...state.userProfile, ...action.payload },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_USER_APP_SETTING_FORM": {
      return {
        ...state,
        userAppSettings: {
          ...state.userAppSettings,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }

    case "UPDATE_PROCESS_COUNT": {
      return {
        ...state,
        processCount: action.payload,
      };
    }
    case "UPDATE_PROCESS_COUNT_AND_TOTAL_IMAGE_PROCESS_ALLOWANCE": {
      return {
        ...state,
        totalCount: action.payload.totalCount,
        processCount: action.payload.processCount,
      };
    }
    case "SET_ORG_LOGO_AND_SIGNATURE_SIGNED_URL": {
      const tempObj = {};

      if (action.payload.length) {
        action.payload.forEach((signedUrlObj) => {
          if (
            signedUrlObj?.s3ObjTypeItem &&
            signedUrlObj.s3ObjTypeItem === "logo" &&
            signedUrlObj?.url
          ) {
            tempObj.orgzLogoUrl = signedUrlObj.url;
          }
          if (
            signedUrlObj?.s3ObjTypeItem &&
            signedUrlObj.s3ObjTypeItem === "signature" &&
            signedUrlObj?.url
          ) {
            tempObj.signatureUrl = signedUrlObj.url;
          }
        });
        return {
          ...state,
          ...tempObj,
        };
      }
    }
    case "GET_CONSULTANT_DATA": {
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          consultantDetails: action.payload,
        },
      };
    }
    default:
      return state;
  }
  return state;
};

// const parseUserSettings = (userSettings) => {
//  let settings = {
//   inputFileLimit: 2,
//   inputFileSize: 10,
//   // Reducing the inputFilesBulk to 10 from 100 for bulk upload demo, Author:Sai
//   // inputFilesBulk: 100,
//   inputFilesBulk: 10,
//   cameraType: "NON-MYDRIATIC",
//   algorithms: ["Normal-Dr-NonDr-Pipeline-2"],
//   imgDimension: "512",
//   cameraModel: "",
//   cameraVendor: "",
//   themeName: "orangeTheme",
//  };
//  for (let i = 0; i < userSettings.length; i++) {
//   settings[`${userSettings[i].property}`] = userSettings[i].value;
//  }
//  return settings;
// };
